export default __webpack_public_path__ + "static/media/Front-Nissan.3b40e2ac.jpg";